import { useTranslation } from "react-i18next";

import { styled } from "simplydo/react/styled";
import { Form, TextArea } from "simplydo/react/ui";

import { Slider as CustomSlider } from "components/lib/UI";

import { FieldProps, SliderFieldValue } from "./FieldProps";

const SliderContainer = styled.div`
  text-align: center;
  > h2 {
    font-size: 50px;
    margin: 20px auto;
  }
  .slider-notes-container {
    margin-top: 35px;
    > p {
      text-align: left;
      font-size: 12px;
      text-transform: uppercase;
      margin-bottom: 4px;
    }
  }
`;

const hasSliderValue = (sliderValue: number | null | undefined) =>
  !(sliderValue === null || sliderValue === undefined);

const Slider = ({
  field,
  fieldValue = {},
  updateIdea,
  isEditing,
}: FieldProps) => {
  const { t } = useTranslation();
  const sliderValue = (fieldValue as SliderFieldValue) || {};
  const { value, notes = "" } = sliderValue;
  const { minslider, maxslider, hideTextbox } = field;

  const min =
    hasSliderValue(minslider) ? minslider
    : hasSliderValue(maxslider) ? 0
    : 1;
  const max = hasSliderValue(maxslider) ? maxslider : 10;

  return (
    <SliderContainer>
      <h2 style={{ color: value === undefined ? "#888" : "black" }}>
        {value ?? "-"}
      </h2>
      {isEditing ?
        <div>
          <CustomSlider
            value={value}
            min={min}
            max={max}
            steps={1}
            onChange={(sliderValue: number) =>
              updateIdea(sliderValue, ["templated", field.id, "value"])
            }
            style={{ marginBottom: 20 }}
          />
          {!hideTextbox ?
            <div className="slider-notes-container">
              <p>{t("ideas.actions.explain.title")}</p>
              <Form>
                <TextArea
                  value={notes}
                  onChange={(_e, { value: notesValue }) =>
                    updateIdea(notesValue as string, [
                      "templated",
                      field.id,
                      "notes",
                    ])
                  }
                />
              </Form>
            </div>
          : null}
        </div>
      : null}
      {!isEditing && notes ?
        <div>
          <p>{notes}</p>
        </div>
      : null}
    </SliderContainer>
  );
};

export default Slider;
